import "./styles.scss"

import React from "react"
import { motion } from "framer-motion"

const engineStartRotate = [
  -8, 8, -8, 8, -8, 8, -8, 8, -8, 8, -8, 8, -8, 8, -8, 8, -8, 8, -8, 8, -8,
]
const engineStartHorizontal = engineStartRotate.map(_ => 0)
const engineStartVertical = engineStartRotate.map(
  (_, index) => (index + 1) * 0.18
)
const engineStartScale = engineStartRotate.map((_, index) => 1 - index * 0.012)

const flyStartHorizontal = 15
const flyStartVertical = -60
const flyStartRotate = 20
const flyStartScale = engineStartScale.at(-1)

const offscreenHorizontal = [-60, -60, 0]
const offscreenVertical = [
  flyStartVertical,
  flyStartVertical * -1,
  flyStartVertical * -1,
]
const offscreenRotate = offscreenHorizontal.map(_ => 0)
const offscreenScale = offscreenHorizontal.map(_ => 1)

const engineStartTimes = engineStartRotate.map(
  (_, index) => (index + 1) * 0.014
)
const flyStartTime = engineStartTimes.at(-1) + 0.08
const offscreenTimes = offscreenHorizontal.map(
  (_, index) => 0.2 + (flyStartTime + index * 0.1)
)

const ResponseIcon = () => {
  return (
    <span className="response-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <motion.g
          animate={{
            x: [
              0,
              ...engineStartHorizontal,
              flyStartHorizontal,
              ...offscreenHorizontal,
              0,
            ],
            y: [
              0,
              ...engineStartVertical,
              flyStartVertical,
              ...offscreenVertical,
              0,
            ],
            rotate: [
              0,
              ...engineStartRotate,
              flyStartRotate,
              ...offscreenRotate,
              0,
            ],
            scale: [
              1,
              ...engineStartScale,
              flyStartScale,
              ...offscreenScale,
              1,
            ],
          }}
          transition={{
            ease: "easeInOut",
            times: [0, ...engineStartTimes, flyStartTime, ...offscreenTimes, 1],
            duration: 4,
            repeat: Infinity,
            repeatDelay: 1
          }}
        >
          <g id="wigns">
            <path
              className="cls-1"
              d="M43.35,43.35h4.65v-6.19c0-2.32-.77-3.87-2.32-5.42l-10.84-10.84H13.16L2.32,31.74c-1.55,1.55-2.32,3.1-2.32,5.42v6.19h43.35Z"
            />
          </g>
          <g id="engine_left">
            <path
              className="cls-4"
              d="M10.84,43.35c0-1.71-1.39-4.65-3.1-4.65s-3.1,2.93-3.1,4.65v3.1h6.19v-3.1Z"
            />
          </g>
          <g id="engine_right">
            <path
              className="cls-4"
              d="M37.16,43.35c0-1.71,1.39-4.65,3.1-4.65s3.1,2.93,3.1,4.65v3.1h-6.19v-3.1Z"
            />
          </g>
          <g id="shape_center">
            <path
              className="cls-4"
              d="M34.84,22.45c0,8.56-1.38,16.25-2.44,20.9-.66,2.92-1.21,4.65-1.21,4.65h-14.39s-.54-1.73-1.21-4.65c-1.06-4.65-2.44-12.34-2.44-20.9,0-.52,0-1.04.03-1.55.15-4.44.93-8.37,2.49-11.61.13-.26.26-.52.39-.77.14-.27.29-.52.44-.77C19.64,2.43,24,0,24,0,24,0,28.36,2.43,31.49,7.74c.15.25.29.51.44.77.14.25.27.51.39.77,1.56,3.25,2.35,7.17,2.49,11.61.02.51.03,1.03.03,1.55Z"
            />
          </g>
          <g id="circle_1">
            <circle className="cls-2" cx="24" cy="20.9" r="6.19" />
          </g>
          <g id="circle_2">
            <circle className="cls-3" cx="24" cy="20.9" r="3.1" />
          </g>
          <g id="line_top">
            <path
              className="cls-1"
              d="M32.32,9.29H15.68c.13-.26.26-.52.39-.77.14-.27.29-.52.44-.77h14.97c.15.25.29.51.44.77.14.25.27.51.39.77Z"
            />
          </g>
        </motion.g>
      </svg>
    </span>
  )
}

export default ResponseIcon
